import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight, Clock, Tag, MessageCircle, Mail } from 'lucide-react';

const Blog = () => {
  const featuredPost = {
    id: 1,
    title: "Transporte de Equipos de Energía Eólica: Nuestro Proyecto Más Desafiante",
    excerpt: "Conoce cómo REZCOM transportó componentes de aerogeneradores de más de 50 toneladas desde el puerto hasta su destino final, superando todos los desafíos logísticos.",
    author: "Carlos Mendoza",
    date: "15 Enero 2025",
    readTime: "8 min lectura",
    category: "Casos de Éxito",
    image: "https://utfs.io/f/5BN0V4mlt4NUfeM7czAcCoK9kqP0BtLvVdTHmWsjUNuG8pOg"
  };

  const blogPosts = [
    {
      id: 2,
      title: "Transporte de Maquinaria Industrial: Operación Compleja en Puerto",
      excerpt: "Caso real de REZCOM: Transporte de equipos industriales de gran tonelaje con grúas especializadas y coordinación portuaria perfecta.",
      author: "María González",
      date: "12 Enero 2025",
      readTime: "6 min lectura",
      category: "Proyectos Realizados",
      image: "https://utfs.io/f/5BN0V4mlt4NUun1NCy259gF0jSNiIaobTk63MY75pshlO2Vw"
    },
    {
      id: 3,
      title: "Componentes de Fundición: Transporte Marítimo Especializado",
      excerpt: "Cómo transportamos cucharas de fundición de 12 toneladas utilizando contenedores flat rack y equipo especializado YANG MING.",
      author: "Roberto Silva",
      date: "10 Enero 2025",
      readTime: "5 min lectura",
      category: "Transporte Marítimo",
      image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80"  // Nueva imagen de puerto de contenedores dinámica
    },
    {
      id: 4,
      title: "Góndolas de Aerogeneradores: Precisión en Cada Movimiento",
      excerpt: "El proceso completo de descarga y manipulación de góndolas de turbinas eólicas con remolques CONDOR y grúas especializadas.",
      author: "Ana López",
      date: "8 Enero 2025",
      readTime: "7 min lectura",
      category: "Energía Renovable",
      image: "https://utfs.io/f/5BN0V4mlt4NUPQGK0rFIFa3KOMUyLeAVcoT7PDkWib8R4Bdu"
    },
    {
      id: 5,
      title: "Nuevos Requisitos Aduaneros: Lo que Debes Saber",
      excerpt: "Actualización completa sobre los cambios en regulaciones aduaneras que afectarán las importaciones y exportaciones en 2025.",
      author: "Luis Herrera",
      date: "5 Enero 2025",
      readTime: "9 min lectura",
      category: "Regulaciones",
      image: "https://utfs.io/f/5BN0V4mlt4NUZTVVCyUTK6QzFRPgbcvS34JeBN2tCIwlfjUp"
    },
    {
      id: 6,
      title: "Tendencias en Almacenamiento Inteligente",
      excerpt: "Cómo la tecnología está revolucionando los centros de distribución y mejorando la eficiencia operativa en nuestras instalaciones.",
      author: "Patricia Ruiz",
      date: "3 Enero 2025",
      readTime: "6 min lectura",
      category: "Tecnología",
      image: "https://utfs.io/f/5BN0V4mlt4NU0AqlEPeXK1e7fx2toMJsnUB0SuRjmzqgk85l"
    }
  ];

  const projectGallery = [
    {
      title: "Transporte de Equipos Petroleros",
      description: "Maquinaria pesada de más de 80 toneladas transportada con éxito",
      image: "https://utfs.io/f/5BN0V4mlt4NUun1NCy259gF0jSNiIaobTk63MY75pshlO2Vw"
    },
    {
      title: "Componentes de Aerogeneradores",
      description: "Góndolas y torres eólicas transportadas desde puerto",
      image: "https://utfs.io/f/5BN0V4mlt4NUfeM7czAcCoK9kqP0BtLvVdTHmWsjUNuG8pOg"
    },
    {
      title: "Operaciones de Grúa Especializada",
      description: "Levantamiento preciso de componentes industriales",
      image: "https://utfs.io/f/5BN0V4mlt4NUPQGK0rFIFa3KOMUyLeAVcoT7PDkWib8R4Bdu"
    },
    {
      title: "Equipo de Fundición Industrial",
      description: "Transporte marítimo con contenedores flat rack en un puerto dinámico",
      image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80"  // Nueva imagen de puerto de contenedores dinámica
    }
  ];

  const categories = ["Todos", "Casos de Éxito", "Proyectos Realizados", "Transporte Marítimo", "Energía Renovable", "Regulaciones", "Tecnología"];

  const handleWhatsAppClick = () => {
    const phoneNumber = "5215562152214";
    const message = "¡Hola REZCOM! Me interesa conocer más sobre sus servicios de logística internacional. ¿Podrían ayudarme con información?";
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  };

  const handleEmailClick = () => {
    const subject = "Consulta desde Blog de REZCOM International";
    const body = "¡Hola REZCOM! \n\nMe gustaría recibir más información sobre sus servicios de logística o tengo una consulta específica. Por favor, pónganse en contacto conmigo.\n\nGracias,";
    const emailURL = `mailto:contacto@rezcom-intl.mx?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = emailURL;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Botón flotante de WhatsApp */}
      <motion.button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300"
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ delay: 2, duration: 0.6, type: "spring" }}
        whileHover={{ 
          scale: 1.1,
          boxShadow: "0 0 30px rgba(34, 197, 94, 0.5)"
        }}
        whileTap={{ scale: 0.9 }}
      >
        <MessageCircle className="w-7 h-7" />
        <motion.div
          className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
      </motion.button>

      {/* Botón flotante de Email */}
      <motion.button
        onClick={handleEmailClick}
        className="fixed bottom-6 left-6 z-50 bg-blue-500 hover:bg-blue-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300"
        initial={{ scale: 0, rotate: 180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ delay: 2.2, duration: 0.6, type: "spring" }}
        whileHover={{ 
          scale: 1.1,
          boxShadow: "0 0 30px rgba(59, 130, 246, 0.5)"
        }}
        whileTap={{ scale: 0.9 }}
      >
        <Mail className="w-7 h-7" />
      </motion.button>

      <motion.section 
        className="bg-gradient-to-r from-green-800 to-green-900 py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="max-w-7xl mx-auto text-center">
          <motion.h1 
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Blog de Logística REZCOM
          </motion.h1>
          <motion.p 
            className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Casos reales, proyectos exitosos y experiencias de nuestros expertos en logística internacional
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-8 flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
          >
            <motion.button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center space-x-2 bg-green-500 hover:bg-green-400 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <MessageCircle className="w-5 h-5" />
              <span>¡Contacta por WhatsApp!</span>
            </motion.button>
            <motion.button
              onClick={handleEmailClick}
              className="inline-flex items-center space-x-2 bg-blue-500 hover:bg-blue-400 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Mail className="w-5 h-5" />
              <span>Enviar Correo</span>
            </motion.button>
          </motion.div>
        </div>
      </motion.section>

      <motion.section 
        className="py-16 px-4 sm:px-6 lg:px-8"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="max-w-7xl mx-auto">
          <motion.div
            className="bg-white rounded-2xl shadow-xl overflow-hidden mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="lg:flex">
              <div className="lg:w-1/2">
                <img
                  src={featuredPost.image}
                  alt={featuredPost.title}
                  className="w-full h-64 lg:h-full object-cover"
                />
              </div>
              <div className="lg:w-1/2 p-8 lg:p-12">
                <div className="flex items-center space-x-4 mb-4">
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    Proyecto Destacado
                  </span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium flex items-center">
                    <Tag className="w-3 h-3 mr-1" />
                    {featuredPost.category}
                  </span>
                </div>
                
                <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                  {featuredPost.title}
                </h2>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {featuredPost.excerpt}
                </p>
                
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <div className="flex items-center">
                      <User className="w-4 h-4 mr-1" />
                      {featuredPost.author}
                    </div>
                    <div className="flex items-center">
                      <Calendar className="w-4 h-4 mr-1" />
                      {featuredPost.date}
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-1" />
                      {featuredPost.readTime}
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <button className="bg-gradient-to-r from-green-600 to-green-800 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2">
                    <span>Leer Caso de Estudio</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                  
                  <motion.button
                    onClick={handleWhatsAppClick}
                    className="border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <MessageCircle className="w-5 h-5" />
                    <span>Consultar por WhatsApp</span>
                  </motion.button>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 text-center">
              Galería de Proyectos Realizados
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {projectGallery.map((project, index) => (
                <motion.div
                  key={index}
                  className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05 }}
                >
                  <div className="relative">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-40 object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="absolute bottom-3 left-3 right-3">
                      <h3 className="text-white font-bold text-sm mb-1">{project.title}</h3>
                      <p className="text-gray-200 text-xs">{project.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <div className="mb-8">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category, index) => (
                <motion.button
                  key={category}
                  className="px-4 py-2 rounded-full border border-gray-300 text-gray-700 hover:bg-green-100 hover:border-green-300 hover:text-green-800 transition-all duration-300"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {category}
                </motion.button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <motion.article
                key={post.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="relative">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-sm font-medium flex items-center">
                      <Tag className="w-3 h-3 mr-1" />
                      {post.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4">
                    <span className="bg-green-600 text-white px-2 py-1 rounded-full text-xs font-medium">
                      Proyecto Real
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {post.title}
                  </h3>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3 text-xs text-gray-500">
                      <div className="flex items-center">
                        <User className="w-3 h-3 mr-1" />
                        {post.author}
                      </div>
                      <div className="flex items-center">
                        <Calendar className="w-3 h-3 mr-1" />
                        {post.date}
                      </div>
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <Clock className="w-3 h-3 mr-1" />
                      {post.readTime}
                    </div>
                  </div>
                  
                  <button className="text-green-600 font-semibold hover:text-green-800 transition-colors duration-300 inline-flex items-center space-x-1">
                    <span>Ver Proyecto</span>
                    <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </motion.article>
            ))}
          </div>

          <motion.div 
            className="text-center mt-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-r from-green-100 to-blue-100 p-8 rounded-2xl mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                ¿Te interesa conocer más proyectos?
              </h3>
              <p className="text-gray-600 mb-6">
                Tenemos una amplia galería de casos de éxito en transporte especializado, 
                desde equipos petroleros hasta componentes de energía renovable.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/contacto"
                  className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
                >
                  <span>Solicitar Portfolio Completo</span>
                  <ArrowRight className="w-5 h-5" />
                </Link>
                
                <motion.button
                  onClick={handleWhatsAppClick}
                  className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <MessageCircle className="w-5 h-5" />
                  <span>Consultar por WhatsApp</span>
                </motion.button>
              </div>
            </div>

            <button className="bg-gradient-to-r from-green-600 to-green-800 text-white px-8 py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 transform hover:scale-105">
              Cargar Más Proyectos
            </button>
          </motion.div>
        </div>
      </motion.section>

      <motion.section 
        className="py-16 bg-gradient-to-r from-green-800 to-green-900 px-4 sm:px-6 lg:px-8"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.h2 
            className="text-3xl sm:text-4xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            ¿Tu próximo proyecto requiere transporte especializado?
          </motion.h2>
          <motion.p 
            className="text-xl text-gray-200 mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Con más de 10 años moviendo los equipos más complejos del mundo, 
            somos la opción confiable para tu logística especializada
          </motion.p>
          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <Link
              to="/cotizacion"
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
            >
              <span>Cotizar Proyecto</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
            
            <motion.button
              onClick={handleWhatsAppClick}
              className="bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp Directo</span>
            </motion.button>
            <motion.button
              onClick={handleEmailClick}
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Mail className="w-5 h-5" />
              <span>Enviar Correo</span>
            </motion.button>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
};

export default Blog;